/* OpenClip Craft PDP. Shopify owns cart quantities and discounts.
 * Card mutations share one queue; pending clicks are a temporary UI overlay. */
(function () {
  'use strict';

  var READY = 'data-craft-ready';
  var CART_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root
    : '/';
  var CART_ADD = CART_ROOT + 'cart/add.js';
  var CART_CHANGE = CART_ROOT + 'cart/change.js';
  var CART_JS = CART_ROOT + 'cart.js';

  function toArray(x) { return Array.prototype.slice.call(x); }

  function formatMoney(cents, currency) {
    currency = currency || 'AUD';
    try {
      return currency === 'AUD' ? 'A$' + new Intl.NumberFormat('en-AU', {minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100) : new Intl.NumberFormat('en-AU', {style:'currency', currency:currency, currencyDisplay:'code'}).format(cents / 100);
    } catch (e) {
      return (currency === 'AUD' ? 'A$' : currency + ' ') + (cents / 100).toFixed(2);
    }
  }

  /* Shared across section reloads: no overlapping mutations or stale hydrations. */
  var cartStore = window.__craftCartStore || (window.__craftCartStore = createCartStore());
  function createCartStore() {
    var cart = null, queue = [], listeners = new Set(), running = false, message = '', failed = false;
    async function request(url, body) {
      var abort = new AbortController(), timer = setTimeout(function () { abort.abort(); }, 20000);
      try {
        var response = await fetch(url, {
          method: body ? 'POST' : 'GET', cache: 'no-store', signal: abort.signal,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: body ? JSON.stringify(body) : undefined
        });
        var result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Bag request failed (' + response.status + ').');
        return result;
      } catch (error) {
        if (error.name === 'AbortError') throw new Error('The bag request timed out. Check your bag before trying again.');
        throw error;
      } finally { clearTimeout(timer); }
    }
    function notify() { listeners.forEach(function (fn) { fn(cart, queue, message, failed); }); }
    function accept(next) {
      if (!next || !Array.isArray(next.items)) throw new Error('Could not read your bag.');
      cart = next;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('.oc-root .bag').forEach(function (el) { el.setAttribute('aria-label', 'Bag, ' + cart.item_count + ' items'); });
    }
    async function drain() {
      if (running) return;
      running = true;
      try {
        if (!cart) { accept(await request(CART_JS)); notify(); }
        while (queue.length) {
          var operation = queue[0];
          if (operation.remove) {
            /* Refresh keys: automatic discounts and external cart edits can change them. */
            accept(await request(CART_JS));
            var line = cart.items.find(function (item) { return String(item.variant_id) === operation.remove && item.quantity > 0; });
            if (!line) throw new Error('That design is no longer in your bag. Quantities have been refreshed.');
            accept(await request(CART_CHANGE, { id: line.key, quantity: line.quantity - 1 }));
          } else {
            await request(CART_ADD, { items: operation.items });
            /* add.js contains only added lines, never the complete cart. */
            accept(await request(CART_JS));
          }
          queue.shift();
          message = queue.length ? 'Updating your bag…' : 'Bag updated.';
          failed = false;
          notify();
          operation.resolve(cart);
        }
      } catch (error) {
        /* No blind retry after an uncertain POST: that could duplicate a paid item. */
        var cancelled = queue.splice(0);
        message = error.message + (cancelled.length > 1 ? ' Remaining changes were cancelled; please check the quantities.' : '');
        failed = true;
        try { accept(await request(CART_JS)); } catch (refreshError) { cart = null; message += ' Open Bag to confirm the current quantities.'; }
        cancelled.forEach(function (operation) { operation.reject(error); });
        notify();
      } finally {
        running = false;
        if (queue.length) drain();
      }
    }
    return {
      subscribe: function (fn) { listeners.add(fn); fn(cart, queue, message, failed); return function () { listeners.delete(fn); }; },
      refresh: function () { if (!running && !queue.length) { cart = null; drain(); } },
      enqueue: function (operation) {
        return new Promise(function (resolve, reject) {
          operation.resolve = resolve; operation.reject = reject; queue.push(operation);
          message = 'Updating your bag…'; failed = false; notify(); drain();
        });
      }
    };
  }

  function initScope(scope) {
    if (!scope || scope.hasAttribute(READY)) return;

    var dataEl = scope.querySelector('[data-craft-pdp-data]');
    if (!dataEl) return;                       /* not the main product section */
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.designs || !data.designs.length) return;

    scope.setAttribute(READY, '');
    var controller = new AbortController();
    var signal = controller.signal;
    scope.__craftController = controller;
    var on = function (el, type, fn) { if (el) el.addEventListener(type, fn, { signal: signal }); };
    var one = function (s) { return scope.querySelector(s); };
    var all = function (s) { return toArray(scope.querySelectorAll(s)); };

    var lazyImages = all('[data-craft-lazy-src]');
    function loadThumb(img) {
      img.src = img.getAttribute('data-craft-lazy-src');
      img.removeAttribute('data-craft-lazy-src');
    }
    if ('IntersectionObserver' in window) {
      var thumbObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { loadThumb(entry.target); thumbObserver.unobserve(entry.target); }
        });
      }, { root: one('.oc-style-grid'), rootMargin: '120px' });
      lazyImages.forEach(function (img) { thumbObserver.observe(img); });
      signal.addEventListener('abort', function () { thumbObserver.disconnect(); }, { once: true });
    } else { lazyImages.forEach(loadThumb); }

    var designs = data.designs;
    var byVariant = {};
    designs.forEach(function (d) { byVariant[String(d.id)] = d; });

    var requestedVariant = new URL(window.location.href).searchParams.get('variant');
    var initialVariant = byVariant[requestedVariant] || byVariant[String(data.initialVariantId)] || designs[0];
    var state = {
      primary: String(initialVariant.id),   /* URL / image / first selector */
      trio: [null, null],                                       /* 2nd and 3rd picker only */
      offer: 'single',
      qty: 1,
      busy: false
    };

    var offerPolicy = window.ocOfferPolicy;
    var eligibleCartCount = null;
    function renderOffer() {
      if (!offerPolicy) return;
      var eligible = offerPolicy.eligible(state.primary), excluded = offerPolicy.excluded(state.primary);
      var box = one('[data-offer-box]'); if (box) box.hidden = !eligible && !excluded;
      var title = one('[data-offer-title]'); if (title) title.textContent = excluded ? offerPolicy.text.excluded_title : offerPolicy.text.title;
      var progress = one('[data-pack-progress]'); if (progress) progress.textContent = excluded ? offerPolicy.text.excluded : offerPolicy.progress(eligibleCartCount);
      var track = one('[data-offer-track]'); if (track) track.hidden = !eligible;
      var scope = one('[data-offer-scope]'); if (scope) scope.hidden = !eligible;
      var bar = one('[data-pack-bar]'); if (bar) bar.style.width = Math.min(100, (eligibleCartCount || 0) / 3 * 100) + '%';
    }
    var pack = {};      /* mirror of this product's lines in the real bag, filled by hydratePack() */
    var cards = all('[data-pack-card]').map(function (card) {
      return { el: card, id: card.dataset.packCard, less: card.querySelector('[data-pack-less]'), more: card.querySelector('[data-pack-more]'), qty: card.querySelector('[data-pack-quantity]'), count: -1 };
    });
    var packFrame = 0;
    function renderPack() {
      packFrame = 0;
      if (signal.aborted || !data.packPicker) return;
      updateMobile();
      var count = kitCount();
      var label = one('[data-pack-count]'); if (label) label.textContent = count + ' kit' + (count === 1 ? '' : 's') + ' in your bag';
      renderOffer();
      cards.forEach(function (card) {
        var n = pack[card.id] || 0;
        if (card.count === n) return;
        card.count = n;
        card.el.classList.toggle('has-quantity', n > 0);
        card.less.hidden = !n; card.less.disabled = !n;
        card.qty.hidden = !n; card.qty.textContent = n;
        card.more.textContent = design(card.id).available ? (n ? '+' : 'Add') : 'Sold out';
        card.more.disabled = !design(card.id).available;
      });
    }
    function schedulePack() { if (!packFrame) packFrame = requestAnimationFrame(renderPack); }
    signal.addEventListener('abort', function () { cancelAnimationFrame(packFrame); });

    /* ------------------------------------------------------------------ render helpers */
    function design(id) { return byVariant[String(id)] || designs[0]; }
    function unitCount() { return state.offer === 'trio' ? 3 : 1; }
    function kitCount() { return data.packPicker ? Object.values(pack).reduce(function(a,b){return a+b;},0) : state.qty * unitCount(); }
    function discountApplies() { return offerPolicy && offerPolicy.eligible(state.primary) && eligibleCartCount >= 3; }
    function displayTotal() {
      /* the trio saving is decided by Shopify at checkout from the bag contents, never here */
      if (data.packPicker) return design(state.primary).price * state.qty;
      var units = designsForSubmit();
      var sum = units.reduce(function (t, d) { return t + d.price; }, 0) * state.qty;
      return sum;
    }
    function designsForSubmit() {
      /* Each card's Add button now adds straight to the bag, so this button means "one more of the
         selected design" — the same thing that card would do. */
      if (data.packPicker) return [design(state.primary)];
      var list = [design(state.primary)];
      if (state.offer === 'trio') {
        list.push(design(state.trio[0] || state.primary));
        list.push(design(state.trio[1] || state.primary));
      }
      return list;
    }

    function applyArtwork(el, d) {
      if (!el) return;
      el.setAttribute('data-artwork-only', d && d.artworkStyle ? String(d.artworkStyle.length) : '0');
      el.style.cssText = d && d.artworkStyle || '';
    }
    var mainImageRequest = 0;
    function setMainImage(d) {
      all('[data-image-restock]').forEach(function(el){ el.hidden = !d.restockMessage; if (d.restockMessage) { var match = d.restockMessage.match(/on (\d+) ([A-Za-z]+)/); if (match) el.textContent = 'Restock expected ' + match[1] + ' ' + match[2].slice(0, 3); } });
      var img = one('[data-craft-main-image]');
      applyArtwork(one('[data-craft-zoom]'), d);
      if (img && img.dataset.previewVariant !== String(d.id)) {
        img.dataset.previewVariant = String(d.id);
        var request = ++mainImageRequest;
        var zoom = one('[data-craft-zoom]'); if (zoom) zoom.disabled = !d.image;
        img.hidden = !d.image;
        img.alt = d.name + (data.imageAltSuffix || ' fabric art design');
        if (d.image) {
          /* Show the already loaded card immediately, never the previous design
             while the responsive main image downloads. */
          var card = one('[data-craft-thumb="' + d.id + '"] img, [data-craft-design="' + d.id + '"] img');
          var preview = d.previewImage || (card && card.complete && card.naturalWidth ? card.currentSrc || card.src : '');
          var target = d.displayImage || d.image;
          var initialMatches = img.getAttribute('src') === target;
          if (preview && !initialMatches) {
            img.removeAttribute('srcset');
            img.src = preview;
            img.style.visibility = '';
          } else if (!initialMatches) {
            img.style.visibility = 'hidden';
          }
          var pending = new Image();
          pending.onload = function () {
            if (signal.aborted || request !== mainImageRequest) return;
            if (pending.srcset) img.srcset = pending.srcset; else img.removeAttribute('srcset');
            img.src = pending.src;
            img.style.visibility = '';
          };
          pending.onerror = function () {
            if (signal.aborted || request !== mainImageRequest) return;
            /* Optimised theme assets may fail independently of the original. */
            pending.onerror = null;
            pending.removeAttribute('srcset');
            pending.src = d.image;
          };
          pending.sizes = img.sizes;
          if (d.imageSrcset) pending.srcset = d.imageSrcset;
          pending.src = target;
        } else {
          img.removeAttribute('src'); img.removeAttribute('srcset');
          img.style.visibility = '';
        }
      }
      var cap = one('[data-craft-media-caption]');
      if (cap) cap.textContent = (data.captionPrefix || 'Design reference') + ' · ' + d.name;
    }

    function renderCakeDetails(d) {
      var garmentActive = !!data.premiumSeries && !!(d && /^OC-KIN-(41|42|43|44|106)$/.test(d.sku));
      document.querySelectorAll('[data-garment-title]').forEach(function(el){ el.textContent = el.dataset.baseTitle + (garmentActive ? ' — Premium Series' : ''); });
      document.querySelectorAll('[data-garment-scope]').forEach(function(el){ el.hidden = !garmentActive; });
      document.querySelectorAll('[data-garment-original]').forEach(function(el){ el.hidden = garmentActive; });
      var intakeSkus = ["OC-KIN-95", "OC-KIN-96", "OC-XMAS-12", "OC-XMAS-13", "OC-XMAS-14", "OC-XMAS-15", "OC-XMAS-16", "OC-XMAS-17", "OC-KIN-97", "OC-KIN-98", "OC-KIN-99", "OC-KIN-100", "OC-XMAS-18", "OC-XMAS-19", "OC-KIN-101", "OC-XMAS-20", "OC-XMAS-21", "OC-KIN-102", "OC-XMAS-22", "OC-XMAS-23", "OC-KIN-103", "OC-KIN-104", "OC-KIN-105"];
      var intakeSelected = String(data.productId) !== '10239261409383' && !!(d && intakeSkus.indexOf(d.sku) !== -1);
      document.querySelectorAll("[data-intake-contents]").forEach(function(el){ el.hidden = !d || el.dataset.intakeContents !== d.sku; });
      document.querySelectorAll("[data-intake-existing-contents]").forEach(function(el){ el.hidden = intakeSelected; });
      if (String(data.productId) === '10239261409383') {
        document.querySelectorAll('[data-sku-contents]').forEach(function(el){ el.hidden = !d || el.dataset.skuContents !== d.sku; });
        return;
      }
      if (String(data.productId) !== '7801986318439' && !data.premiumSeries) return;
      var isCake = d && d.sku === 'OC-KIN-35';
      document.querySelectorAll('[data-standard-inclusion]').forEach(function(el){ el.hidden = !!(d && /^OC-KIN-(35|36|37|38|39|40|41|42|43|44|106)$/.test(d.sku)); });
      document.querySelectorAll('[data-sku-contents]').forEach(function(el){ el.hidden = !d || el.dataset.skuContents !== d.sku; });
      document.querySelectorAll('[data-deluxe-quality]').forEach(function(el){ el.hidden = !(d && /^OC-KIN-(35|40|41|42|43|44|106)$/.test(d.sku)); });
      var isBird = d && /^OC-KIN-(45|46|47|48)$/.test(d.sku);
      all('[data-bird-design-note]').forEach(function(el){ el.hidden = !isBird; });
      document.querySelectorAll('[data-bird-kit-contents]').forEach(function(el){ el.hidden = !isBird; });
      var isBundle = d && /^OC-KIN-(36|37|38|39)$/.test(d.sku);
      var isFramed = d && /^OC-KIN-(40|41|42|43|44|106)$/.test(d.sku);
      all('[data-framed-design-note]').forEach(function(el){ el.hidden = !isFramed || garmentActive; });
      all('[data-framed-size]').forEach(function(el){ el.textContent = d.sku === 'OC-KIN-43' ? '15 × 20 cm' : d.sku === 'OC-KIN-44' ? '15 × 15 cm' : '20 × 20 cm'; });
      document.querySelectorAll('[data-framed-kit-contents],[data-framed-process]').forEach(function(el){ el.hidden = !isFramed; });
      document.querySelectorAll('[data-default-process]').forEach(function(el){ el.hidden = false; });
      all('[data-bundle-design-note]').forEach(function(el){ el.hidden = !isBundle; });
      document.querySelectorAll('[data-bundle-kit-contents]').forEach(function(el){ el.hidden = !isBundle; });
      all('[data-cake-design-note]').forEach(function(el){ el.hidden = !isCake; });
      document.querySelectorAll('[data-cake-kit-contents]').forEach(function(el){ el.hidden = !isCake; });
      document.querySelectorAll('[data-default-kit-contents]').forEach(function(el){ el.hidden = isCake || isBundle || isFramed || isBird; });
    }

    function render() {
      renderOffer();
      var primary = design(state.primary);
      renderCakeDetails(primary);
      var primarySelect = one('#craft-design-1');if(primarySelect)primarySelect.value=state.primary;
      var priceEl=one('[data-craft-unit-price]');if(priceEl){priceEl.replaceChildren(document.createTextNode(formatMoney(primary.price, data.currency)+' '));var currency=document.createElement('span');currency.textContent='per kit';priceEl.append(currency);if(primary.compareAt>primary.price){var old=document.createElement('s');old.textContent=formatMoney(primary.compareAt, data.currency);priceEl.append(old);}}
      var offerPrices=all('.offer b');if(offerPrices[0])offerPrices[0].textContent=formatMoney(primary.price, data.currency);if(offerPrices[1]){var trioSum=primary.price+design(state.trio[0]||designs[1]?.id||state.primary).price+design(state.trio[1]||designs[2]?.id||state.primary).price;offerPrices[1].textContent=formatMoney(trioSum, data.currency);}

      all('[data-craft-design]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(String(b.getAttribute('data-craft-design')) === String(state.primary)));
      });
      all('[data-craft-thumb]').forEach(function (b) {
        var on_ = String(b.getAttribute('data-craft-thumb')) === String(state.primary);
        b.classList.toggle('selected', on_);
        b.setAttribute('aria-pressed', String(on_));
      });

      var nameEl = one('[data-craft-selected-name]');
      if (nameEl) nameEl.textContent = primary.name;

      var trioBox = one('[data-craft-trio-selectors]');
      if (trioBox) trioBox.hidden = state.offer !== 'trio';
      var firstLabel = one('[data-craft-first-label]');
      if (firstLabel) firstLabel.textContent = state.offer === 'trio' ? 'First design' : 'Your design';

      var total = one('[data-craft-total]');
      if (total) total.textContent = formatMoney(displayTotal(), data.currency);

      var qty = one('[data-craft-quantity]');
      if (qty && String(qty.value) !== String(state.qty)) qty.value = state.qty;

      var stickyTitle = one('[data-craft-sticky-title]');
      if (stickyTitle) stickyTitle.textContent = state.offer === 'trio' ? (data.trioStickyTitle || 'Your three kits') : primary.name;
      var stickyPrice = one('[data-craft-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(displayTotal(), data.currency);

      var note = one('[data-craft-delivery-note]');
      if (note) note.textContent = discountApplies() ? (data.deliveryTrio || '') : (data.deliverySingle || '');

      var firstThumb = one('[data-craft-sel-thumb="0"]');
      if (firstThumb) { firstThumb.src = primary.thumbnail || primary.image; firstThumb.alt = primary.name; }
      [0, 1].forEach(function (i) {
        var t = one('[data-craft-sel-thumb="' + (i + 1) + '"]');
        var d = design(state.trio[i] || state.primary);
        if (t) { t.src = d.thumbnail || d.image; t.alt = d.name; }
      });

      var formId = one('[data-craft-variant-input]');
      if (formId) formId.value = state.primary;

      var soldOut = designsForSubmit().some(function(d){return !d.available;}) || (data.packPicker && kitCount() === 0 && !primary.available);
      all('[data-craft-buy], [data-craft-sticky-add]').forEach(function (b) {
        /* the button adds the selected design, so it does not depend on what the bag mirror holds */
        b.disabled = soldOut || state.busy;
        b.setAttribute('aria-disabled', String(soldOut || state.busy));
      });
      var soldEl = one('[data-craft-sold-out]');
      if (soldEl) { soldEl.hidden = !soldOut; soldEl.textContent = soldOut ? (data.soldOutMessage || 'This design is sold out.') : ''; }
      var restockEl = one('[data-craft-restock]');
      if (restockEl) { restockEl.hidden = !primary.restockMessage; restockEl.textContent = primary.restockMessage || ''; }
      if (data.packPicker) renderPack();

    }

    function selectPrimary(id, updateUrl) {
      if (!byVariant[String(id)]) return;
      state.primary = String(id);
      renderCakeDetails(design(state.primary));
      if (mobileDialog && mobileDialog.open) { updateMobile(); if (updateUrl !== false) syncUrl(); return; }
      setMainImage(design(state.primary));
      render();
      if (updateUrl !== false) syncUrl();
    }

    /* ------------------------------------------------------------------ URL state (spec 3.5–3.6) */
    function syncUrl() {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', state.primary);
        window.history.replaceState({ craftVariant: state.primary }, '', url.toString());
      } catch (e) { /* older browsers: leave the URL alone rather than break */ }
    }
    on(window, 'popstate', function () {
      try {
        var v = new URL(window.location.href).searchParams.get('variant');
        if (v && byVariant[v]) selectPrimary(v, false); else selectPrimary(initialVariant.id, !!v);
      } catch (e) { /* ignore */ }
    });
    on(window, 'pageshow', function (ev) {
      if (!ev.persisted) return;
      try {
        var v = new URL(window.location.href).searchParams.get('variant');
        if (v && byVariant[v]) selectPrimary(v, false); else selectPrimary(initialVariant.id, !!v);
      } catch (e) { /* ignore */ }
    });

    /* Mobile design sheet shares the existing variant state and cart queue. */
    var mobileDialog = one('[data-mobile-design-dialog]');
    var mobileMedia = window.matchMedia('(max-width: 767px)');
    var mobilePending = false, mobileCartCount = null, mobileImageRequest = 0, mobileFocus = null;
    var mobileScrollStyle = '', mobileScrollX = 0, mobileScrollY = 0, mobileGridScroll = 0;
    function mobileEnabled() { return !!mobileDialog && mobileMedia.matches; }
    function mobileIds() { return all('[data-craft-thumb]').filter(function(b){var card=b.closest('.oc-style-card');return !card || !card.hidden;}).map(function(b){return b.getAttribute('data-craft-thumb');}); }
    var mobileImages = new Map();
    function prepareMobileImage(d) {
      var key = String(d.id);
      if (mobileImages.has(key)) return mobileImages.get(key);
      var entry = { image: new Image(), ready: false, promise: null };
      var responsive = (d.imageSrcset || '').split(',').map(function(s){return s.trim();}).find(function(s){return / 640w$/.test(s);});
      var src = responsive ? responsive.replace(/ 640w$/, '') : d.displayImage || d.image;
      entry.promise = new Promise(function(resolve,reject){
        var fallback = false;
        entry.image.onload = function(){
          var decoded = entry.image.decode ? entry.image.decode() : Promise.resolve();
          decoded.then(function(){entry.ready=true;resolve(entry.image);}).catch(function(){mobileImages.delete(key);reject(new Error('Image could not be decoded'));});
        };
        entry.image.onerror = function(){
          if(!fallback && d.image && src !== d.image){fallback=true;entry.image.src=d.image;}
          else {mobileImages.delete(key);reject(new Error('Image could not be loaded'));}
        };
        entry.image.decoding = 'async'; entry.image.src = src;
      });
      mobileImages.set(key,entry);
      return entry;
    }
    function warmMobileNeighbours() {
      var ids=mobileIds(),i=ids.indexOf(state.primary);
      [-1,1].forEach(function(delta){if(ids.length>1)prepareMobileImage(design(ids[(i+delta+ids.length)%ids.length])).promise.catch(function(){});});
    }

    function updateMobile() {
      renderOffer();
      if (!mobileDialog) return;
      var d = design(state.primary), n = kitCount(), count = one('[data-mobile-bag-count]');
      if (count) count.textContent = mobileCartCount === null ? 'Your bag' : mobileCartCount + ' item' + (mobileCartCount === 1 ? '' : 's') + ' in your bag';
      var hint = one('[data-mobile-bag-hint]');
      if (hint && offerPolicy) hint.textContent = offerPolicy.excluded(state.primary) ? offerPolicy.text.excluded : offerPolicy.eligible(state.primary) ? offerPolicy.progress(eligibleCartCount) : offerPolicy.text.other;
      if (!mobileDialog.open) return;
      applyArtwork(one('[data-mobile-artwork]'), d);
      one('[data-mobile-name]').textContent = d.name;
      one('[data-mobile-price]').textContent = formatMoney(d.price, data.currency);
      var mobileImageRestock = one('[data-mobile-image-restock]');
      if (mobileImageRestock) { mobileImageRestock.hidden = !d.restockMessage; if (d.restockMessage) { var match = d.restockMessage.match(/on (\d+) ([A-Za-z]+)/); if (match) mobileImageRestock.textContent = 'Restock expected ' + match[1] + ' ' + match[2].slice(0, 3); } }
      var mobileRestock = one('[data-mobile-restock]');
      if (mobileRestock) { mobileRestock.hidden = !d.restockMessage; mobileRestock.textContent = d.restockMessage || ''; }
      var ids = mobileIds(), index = ids.indexOf(state.primary);
      one('[data-mobile-position]').textContent = (index + 1) + ' / ' + ids.length;
      all('[data-mobile-step]').forEach(function(b){b.disabled=ids.length<2;});
      var add = one('[data-mobile-add]');
      add.disabled = mobilePending || !d.available;
      add.textContent = !d.available ? 'Sold out' : mobilePending ? 'Adding…' : 'Add to bag · ' + formatMoney(d.price, data.currency);
      var qty = pack[state.primary] || 0;
      one('[data-mobile-quantity]').textContent = qty ? qty + ' of this design in your bag' : '';
      var img = one('[data-mobile-image]');
      if (img.dataset.variant !== state.primary) {
        var key = state.primary, token = ++mobileImageRequest;
        img.dataset.variant = key;
        var entry = prepareMobileImage(d);
        function commit(image) {
          if(signal.aborted || token !== mobileImageRequest || state.primary !== key)return;
          var old = one('[data-mobile-image]');
          image.setAttribute('data-mobile-image',''); image.dataset.variant=key;
          image.alt=d.name+(data.imageAltSuffix || ' fabric art design'); image.width=960; image.height=960;
          image.draggable=false;
          if(old !== image)old.replaceWith(image);
          image.style.visibility='';
          one('.oc-mobile-stage').removeAttribute('aria-busy');
          one('[data-mobile-image-loading]').hidden=true;
          updateMobile(); warmMobileNeighbours();
        }
        if(entry.ready)commit(entry.image);
        else {
          /* Never paint the previous design beneath the new variant name. */
          var mainPreview = one('[data-craft-main-image]');
          var preview = mainPreview && mainPreview.dataset.previewVariant === String(key) && mainPreview.naturalWidth ? (mainPreview.currentSrc || mainPreview.src) : d.previewImage;
          if(preview){
            var placeholder = document.createElement('img');
            placeholder.setAttribute('data-mobile-image',''); placeholder.dataset.variant=key;
            placeholder.alt=d.name+(data.imageAltSuffix || ' fabric art design'); placeholder.width=960;placeholder.height=960;placeholder.draggable=false;
            placeholder.src=preview; img.replaceWith(placeholder);
          } else { img.style.visibility='hidden'; }
          one('.oc-mobile-stage').setAttribute('aria-busy','true');
          one('[data-mobile-image-loading]').textContent='Loading image…';
          one('[data-mobile-image-loading]').hidden=!!preview;
          entry.promise.then(commit).catch(function(){
            if(token !== mobileImageRequest || signal.aborted)return;
            one('[data-mobile-image-loading]').textContent='Image unavailable. Select another design and try again.';
          });
        }
      }
      add.disabled = mobilePending || !d.available || one('.oc-mobile-stage').getAttribute('aria-busy') === 'true';
    }

    function closeMobile() { if (mobileDialog && mobileDialog.open) mobileDialog.close(); }
    function openMobile() {
      if (!mobileEnabled()) return;
      mobileFocus = document.activeElement;
      mobileScrollX = window.scrollX; mobileScrollY = window.scrollY;
      mobileGridScroll = one('.oc-style-grid').scrollTop;
      if (!mobileDialog.open) {
        mobileScrollStyle = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        mobileDialog.showModal();
      }
      one('[data-mobile-status]').textContent = '';
      updateMobile();
    }
    function stepMobile(delta) {
      var ids = mobileIds(); if (ids.length < 2) return;
      var i = ids.indexOf(state.primary);
      selectPrimary(ids[(i + delta + ids.length) % ids.length]);
      one('[data-mobile-status]').textContent = '';
      updateMobile();
    }
    if (mobileDialog) {
      /* Keep the existing signup teaser above the mobile bag bar. */
      var teaserAttempts = 0, teaserStyles = [];
      function placeTeaser() {
        document.querySelectorAll('shopify-forms-embed').forEach(function(host){
          var shadow = host.shadowRoot;
          if (!shadow || shadow.querySelector('[data-oc-mobile-teaser]')) return;
          var style = document.createElement('style');
          style.setAttribute('data-oc-mobile-teaser','');
          style.textContent = '@media(max-width:767px){#app-embed[data-current-step="tease"][data-position^="bottom"]{bottom:calc(92px + env(safe-area-inset-bottom))!important}}';
          shadow.appendChild(style); teaserStyles.push(style);
        });
        if (++teaserAttempts >= 20 || teaserStyles.length) clearInterval(teaserTimer);
      }
      var teaserTimer = setInterval(placeTeaser, 500); placeTeaser();
      signal.addEventListener('abort',function(){clearInterval(teaserTimer);teaserStyles.forEach(function(s){s.remove();});});
      on(mobileDialog, 'close', function(){document.documentElement.style.overflow=mobileScrollStyle;setMainImage(design(state.primary));render();if(mobileFocus && mobileFocus.isConnected)mobileFocus.focus({preventScroll:true});requestAnimationFrame(function(){window.scrollTo(mobileScrollX,mobileScrollY);one('.oc-style-grid').scrollTop=mobileGridScroll;});});
      all('[data-mobile-close]').forEach(function(b){on(b,'click',closeMobile);});
      all('[data-mobile-step]').forEach(function(b){on(b,'click',function(){stepMobile(Number(b.dataset.mobileStep));});});
      on(mobileDialog,'keydown',function(e){if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();stepMobile(e.key==='ArrowLeft'?-1:1);}});
      on(one('[data-mobile-add]'),'click',function(){
        var d = design(state.primary); if (mobilePending || !d.available) return;
        mobilePending = true; updateMobile();
        one('[data-mobile-status]').textContent = 'Adding ' + d.name + '…';
        cartStore.enqueue({items:[{id:Number(d.id),quantity:1}]}).then(function(){
          if(!signal.aborted)one('[data-mobile-status]').textContent = d.name + ' added to your bag.';
        }).catch(function(error){if(!signal.aborted)one('[data-mobile-status]').textContent = error.message;}).finally(function(){mobilePending=false;if(!signal.aborted)updateMobile();});
      });
      var gesture = null, swipeImage = one('.oc-mobile-stage');
      var imageLoading = document.createElement('span'); imageLoading.setAttribute('data-mobile-image-loading',''); imageLoading.textContent='Loading image…'; imageLoading.hidden=true; imageLoading.style.cssText='position:absolute;inset:40% 50px auto;text-align:center;font-size:14px;color:#6a2238'; swipeImage.appendChild(imageLoading);
      on(swipeImage,'pointerdown',function(e){if(!e.isPrimary||e.button!==0||e.target.closest('button'))return;gesture={id:e.pointerId,x:e.clientX,y:e.clientY};swipeImage.setPointerCapture(e.pointerId);});
      on(swipeImage,'pointerup',function(e){if(!gesture||gesture.id!==e.pointerId)return;var dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;gesture=null;if(swipeImage.hasPointerCapture(e.pointerId))swipeImage.releasePointerCapture(e.pointerId);if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3)stepMobile(dx<0?1:-1);});
      on(swipeImage,'pointercancel',function(){gesture=null;});
      on(mobileMedia,'change',function(){if(!mobileMedia.matches)closeMobile();});
      signal.addEventListener('abort',function(){if(mobileDialog.open)closeMobile();document.documentElement.style.overflow=mobileScrollStyle;});
    }

    /* ------------------------------------------------------------------ wiring */
    all('[data-pack-more]').forEach(function (btn) { on(btn, 'click', function () {
      var id = btn.dataset.packMore;
      if (!design(id).available) return;
      cartStore.enqueue({ items: [{ id: Number(id), quantity: 1 }] }).catch(function () {});
      /* Start the cart request first; preview changes never gate a queued Add. */
      if (state.primary !== String(id)) selectPrimary(id);
    }); });
    all('[data-pack-less]').forEach(function (btn) { on(btn, 'click', function () {
      var id = btn.dataset.packLess;
      if (!(pack[id] > 0)) return;
      cartStore.enqueue({ remove: id }).catch(function () {});
    }); });
    all('[data-pack-filter]').forEach(function(btn){on(btn,'click',function(){
      all('[data-pack-filter]').forEach(function(b){b.setAttribute('aria-pressed',String(b===btn));});
      all('[data-pack-card]').forEach(function(card){card.hidden=btn.dataset.packFilter!=='all'&&card.dataset.category!==btn.dataset.packFilter&&card.dataset.tier!==btn.dataset.packFilter;});
      one('.oc-style-grid').scrollTop=0;
    });});

    all('[data-craft-design]').forEach(function (btn) {
      on(btn, 'click', function () {
        selectPrimary(btn.getAttribute('data-craft-design'));
        var dlg = one('#craft-design-dialog');
        if (dlg && dlg.open) dlg.close();
      });
    });
    all('[data-craft-thumb]').forEach(function (btn) {
      on(btn, 'click', function () { selectPrimary(btn.getAttribute('data-craft-thumb')); if (mobileEnabled()) openMobile(); });
    });

    on(one('#craft-design-1'),'change',function(e){selectPrimary(e.target.value);});
    [0, 1].forEach(function (i) {
      var sel = one('[data-craft-trio-select="' + i + '"]');
      if (!sel) return;
      on(sel, 'change', function () { state.trio[i] = sel.value; render(); });
    });

    all('[data-craft-offer]').forEach(function (input) {
      on(input, 'change', function () {
        if (!input.checked) return;
        state.offer = input.value;
        /* keep the trio pickers on something real the first time the offer opens */
        if (state.offer === 'trio') {
          if (!state.trio[0]) state.trio[0] = (designs[1] || designs[0]).id;
          if (!state.trio[1]) state.trio[1] = (designs[2] || designs[0]).id;
          [0, 1].forEach(function (i) {
            var s = one('[data-craft-trio-select="' + i + '"]');
            if (s) s.value = state.trio[i];
          });
        }
        render();
      });
    });

    function setQty(n) {
      var v = Math.floor(Number(n));
      if (!isFinite(v)) v = 1;
      state.qty = Math.min(10, Math.max(1, v));      /* preview cap; real limits come from Shopify */
      render();
    }
    var inc = one('[data-craft-increase]'), dec = one('[data-craft-decrease]'), qtyInput = one('[data-craft-quantity]');
    on(inc, 'click', function () { setQty(state.qty + 1); });
    on(dec, 'click', function () { setQty(state.qty - 1); });
    on(qtyInput, 'change', function () { setQty(qtyInput.value); });
    on(qtyInput,'input',function(){if(qtyInput.value!=='')setQty(qtyInput.value);});

    all('[data-craft-open-designs]').forEach(function (b) {
      on(b, 'click', function () { var d = one('#craft-design-dialog'); if (d) d.showModal(); });
    });

    
    function openDesignPreview() {
      if (mobileEnabled()) { openMobile(); return; }
      var src = one('[data-craft-main-image]'), dst = one('[data-craft-zoom-image]'), dlg = one('[data-craft-zoom-dialog]');
      if (!src || !dst || !dlg || !design(state.primary).image) return;
      applyArtwork(one('[data-zoom-artwork]'), design(state.primary));
      var full = design(state.primary).image;
      dst.src = src.currentSrc || src.src || full; dst.alt = src.alt;
      dst.dataset.zoomSource = full;
      var hi = new Image(); hi.onload = function(){ if(dlg.open && dst.dataset.zoomSource === full)dst.src = full; }; hi.src = full;
      dlg.setAttribute('aria-label', design(state.primary).name + ' — image detail');
      if (!dlg.open) dlg.showModal();
    }
    on(one('[data-craft-zoom]'), 'click', openDesignPreview);

    all('[data-craft-close]').forEach(function (b) {
      on(b, 'click', function () {
        var d = document.getElementById(b.getAttribute('data-craft-close'));
        if (d) d.close();
      });
    });
    all('dialog').forEach(function (d) {
      on(d, 'click', function (e) {
        if (e.target !== d) return;
        var r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
      });
    });

    /* ------------------------------------------------------------------ real cart add (spec 3) */
    function status(msg, isError) {
      var el = one('[data-craft-status]');
      if (!el) return;
      el.textContent = msg || '';
      el.classList.toggle('is-error', !!isError);
    }

    function showConfirmation(cart) {
      var dlg = one('[data-craft-cart-confirmation]');
      var lines = dlg && dlg.querySelector('[data-craft-cart-lines]');
      if (!lines || signal.aborted) return;
      lines.replaceChildren();
      cart.items.forEach(function (item) {
        var row = document.createElement('div'); row.className = 'craft-cart-line';
        var img = document.createElement('img'); if (item.image) img.src = item.image; else img.hidden = true;
        img.alt = item.variant_title || item.product_title;
        var label = document.createElement('span');
        label.textContent = (item.variant_title || item.product_title) + ' · Qty ' + item.quantity + ' · ' + formatMoney(item.final_line_price, cart.currency);
        row.append(img, label); lines.append(row);
      });
      dlg.querySelector('[data-craft-cart-subtotal]').textContent = 'Subtotal ' + formatMoney(cart.total_price, cart.currency);
      if (!dlg.open) dlg.showModal();
    }
    var unsubscribe = cartStore.subscribe(function (cart, operations, message, failed) {
      var next = {};
      if (cart) cart.items.forEach(function (item) {
        var id = String(item.variant_id);
        if (byVariant[id]) next[id] = (next[id] || 0) + item.quantity;
      });
      operations.forEach(function (operation) {
        if (operation.remove) next[operation.remove] = Math.max(0, (next[operation.remove] || 0) - 1);
        else operation.items.forEach(function (item) { var id = String(item.id); if (byVariant[id]) next[id] = (next[id] || 0) + item.quantity; });
      });
      eligibleCartCount = offerPolicy ? offerPolicy.count(cart) : null;
      renderOffer();
      mobileCartCount = cart ? cart.item_count : null;
      pack = next; schedulePack(); status(message, failed);
    });
    signal.addEventListener('abort', unsubscribe);
    cartStore.refresh();
    on(window, 'pageshow', function (event) { if (event.persisted) cartStore.refresh(); });
    on(window, 'focus', function () { cartStore.refresh(); });

    function addToCart() {
      if (state.busy) return;
      if (designsForSubmit().some(function (d) { return !d.available; })) {
        status(data.soldOutMessage || 'This design is sold out.', true); return;
      }
      var merged = {};
      designsForSubmit().forEach(function (d) { merged[d.id] = (merged[d.id] || 0) + (data.packPicker ? 1 : state.qty); });
      var items = Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });
      state.busy = true; render();
      cartStore.enqueue({ items: items }).then(showConfirmation).catch(function () {}).finally(function () {
        state.busy = false; if (!signal.aborted) render();
      });
    }

    var form = one('[data-craft-form]');
    on(form, 'submit', function (e) { e.preventDefault(); addToCart(); });
    all('[data-craft-sticky-add]').forEach(function (b) {
      on(b, 'click', function () { if (form) form.requestSubmit ? form.requestSubmit() : addToCart(); });
    });

    /* ------------------------------------------------------------------ sticky bar (spec 3) */
    var mainBtn = one('[data-craft-buy]');
    var sticky = one('[data-craft-sticky]');
    if (mainBtn && sticky) {
      var stickyFrame = 0;
      function updateSticky() {
        stickyFrame = 0;
        var rect = mainBtn.getBoundingClientRect();
        sticky.hidden = data.stickyWhenOffscreen
          ? (rect.bottom > 80 && rect.top < window.innerHeight - 80)
          : rect.bottom > 0;
      }
      function scheduleSticky() {
        if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(scheduleSticky, { threshold: 0 });
        io.observe(mainBtn);
        signal.addEventListener('abort', function () { io.disconnect(); });
      }
      window.addEventListener('scroll', scheduleSticky, {passive:true, signal:signal});
      on(window, 'resize', scheduleSticky);
      signal.addEventListener('abort', function(){cancelAnimationFrame(stickyFrame);});
      updateSticky();
    }

    /* ------------------------------------------------------------------ video defaults (spec 3) */
    all('video').forEach(function (v) {
      v.defaultMuted = true;
      v.muted = true;
      on(v, 'play', function () {
        all('video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      });
    });

    selectPrimary(state.primary, !byVariant[new URL(location.href).searchParams.get('variant')] && new URL(location.href).searchParams.has('variant'));
    setMainImage(design(state.primary));
    render();
  }

  function teardown(scope) {
    if (!scope) return;
    if (scope.__craftController) { scope.__craftController.abort(); scope.__craftController = null; }
    scope.removeAttribute(READY);
  }

  function scopeFrom(node) {
    if (!node || node.nodeType !== 1) return null;
    if (node.matches('[data-craft-section]')) return node;
    return node.querySelector('[data-craft-section]');
  }

  function initAll(root) {
    toArray((root || document).querySelectorAll('[data-craft-section]')).forEach(initScope);
    updateNav();
  }

  function updateNav() {
    document.querySelectorAll('[data-craft-nav-target]').forEach(function(link) {
      var target=document.getElementById(link.dataset.craftNavTarget);
      link.hidden=!target || !target.getClientRects().length;
    });
  }
  document.addEventListener('click', function(e) {
    var link=e.target.closest('[data-craft-open-designs]');
    if(!link)return;
    var main=document.querySelector('[data-craft-section="main-product"]');
    var dialog=main && main.querySelector('#craft-design-dialog');
    var grid=main && main.querySelector('.oc-style-grid');
    if(dialog){e.preventDefault();if(!dialog.open)dialog.showModal();}
    else if(grid){e.preventDefault();grid.scrollIntoView({block:'center'});grid.focus();}
  });
  ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(function(event) {
    document.addEventListener(event,function(){requestAnimationFrame(updateNav);});
  });

  document.addEventListener('shopify:section:load', function (e) {
    var s = scopeFrom(e.target); if (s) initScope(s); else initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    toArray(e.target.querySelectorAll('[data-craft-section]')).forEach(teardown);
    if (e.target.matches && e.target.matches('[data-craft-section]')) teardown(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var s = scopeFrom(e.target);
    if (s) initScope(s);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();

/* GIFs are intentional, pausable playback: no eager 50MB download and no clipped steps. */
document.addEventListener('click',function(e){var btn=e.target.closest('[data-craft-gif]');if(!btn)return;var playing=btn.getAttribute('aria-pressed')==='true';btn.querySelector('img').src=playing?btn.dataset.craftPoster:btn.dataset.craftGif;btn.setAttribute('aria-pressed',String(!playing));btn.querySelector('span').textContent=playing?'Play':'Pause';btn.setAttribute('aria-label',(playing?'Play: ':'Pause: ')+(btn.dataset.craftStepTitle||btn.querySelector('img').alt));});
